import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";

const getInitialLanguage = () => {
  const savedLang = localStorage.getItem("i18nextLng");
  if (savedLang && (savedLang === "ar" || savedLang === "en")) {
    return savedLang;
  }

  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang) {
    if (browserLang.toLowerCase().startsWith("ar")) {
      return "ar";
    }
    if (browserLang.toLowerCase().startsWith("en")) {
      return "en";
    }
  }

  return "ar";
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: "ar",
    debug: false,
    defaultNS: "global",
    ns: ["global"],
    returnNull: false,
    returnEmptyString: false,
    backend: {
      loadPath: "/translations/{{lng}}/global.json",
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      // Check browser language first if no saved language
      checkWhitelist: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("initialized", () => {
  const lng = i18n.language;
  const dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lng);

  updateAxiosHeaders(lng);
});

i18n.on("languageChanged", lng => {
  const dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lng);

  localStorage.setItem("i18nextLng", lng);

  window.dispatchEvent(
    new CustomEvent("languageChanged", {
      detail: { language: lng, direction: dir },
    }),
  );

  updateAxiosHeaders(lng);
});

const updateAxiosHeaders = language => {
  axios.defaults.headers.common["Accept-Language"] = language;
  axios.defaults.headers.common["lang"] = language;
};

export default i18n;
